
import {addPermissionRooms,deletePermissionRooms,updatePermissionRooms,getPermissionRooms,getPermissionRoom,searchPermissionRooms } from '@/services/endpoints/permissionRooms'
import statuses from "@/constatnts/statuses";

export default {
    async addPermissionRooms({ commit }, payload) {
        try {
            let res = await addPermissionRooms(payload)
            if(res) {
                return res.data
            }
            else{
                throw {}
            }
        }
        catch (err) {
            throw err
        }
    },


    async deletePermissionRooms({commit}, payload) {
        try {
            let res = await deletePermissionRooms(payload.permissionRoomsId);
            if (res) {
                return res.data
            } else {
                throw {}
            }
        } catch (err) {
            throw err
        }
    },
    async getPermissionRooms({ commit },payload) {
        try {
            let res = await getPermissionRooms(payload);
            if(res) {
                commit('SET_PERMISSION_ROOMS', res.data.data)
                commit('SET_TOTAL', res.data.total)
                return res.data.data
            }
        }
        catch (err) {
            throw new Error(err)
        }
    },
    async getActivePermissionRooms({ commit }) {
        try {
            let res = await searchPermissionRooms({status: statuses.ACTIVE});
            if(res) {
                commit('SET_PERMISSION_ROOMS', res.data.data)
                return res.data.data
            }
        }
        catch (err) {
            throw new Error(err)
        }
    },
    async updatePermissionRooms({commit},payload) {
        try {
            let res = await updatePermissionRooms(payload.id, payload.payload);
            if(res) {
                return res.data
            }
            else{
                throw {}
            }
        }
        catch (err) {
            throw err
        }
    },
    async searchPermissionRooms({ commit }, payload) {
        try {
            let res = await searchPermissionRooms(payload);
            if(res) {
                commit('SET_PERMISSION_ROOMS', res.data.data)
                commit('SET_TOTAL', res.data.total)
                return res.data.data
            }
        }
        catch (err) {
            throw new Error(err)
        }
    },
    async getPermissionRoom({ commit }, permissionRoomsId) {
        try {
            let res = await getPermissionRoom(permissionRoomsId);
            if(res) {
                commit('SET_PERMISSION_ROOMS_TO_EDIT', res.data)
                return res.data
            }
        }
        catch (err) {
            throw new Error(err)
        }
    },
}